// Built-in password gate strings per help center language, copied from the
// help center app (HelpCenterApp helper/translations.ts) so the widget gate
// matches the direct help center page. Dashboard overrides still win.
export const passwordGateTranslations: Record<string, Record<string, string>> = {
  en: {
    loginTitle: "Provide a password to continue",
    passwordLabel: "Password",
    continueButton: "Continue",
    errorMessage: "The password is not correct!",
  },
  de: {
    loginTitle: "Geben Sie ein Passwort ein, um fortzufahren",
    passwordLabel: "Passwort",
    continueButton: "Weiter",
    errorMessage: "Das Passwort ist nicht korrekt!",
  },
  es: {
    loginTitle: "Proporcione una contraseña para continuar",
    passwordLabel: "Contraseña",
    continueButton: "Continuar",
    errorMessage: "¡La contraseña no es correcta!",
  },
  fr: {
    loginTitle: "Fournissez un mot de passe pour continuer",
    passwordLabel: "Mot de passe",
    continueButton: "Continuer",
    errorMessage: "Le mot de passe n'est pas correct !",
  },
  pt: {
    loginTitle: "Forneça uma senha para continuar",
    passwordLabel: "Senha",
    continueButton: "Continuar",
    errorMessage: "A senha não está correta!",
  },
  az: {
    loginTitle: "Davam etmək üçün şifrəni daxil edin",
    passwordLabel: "Şifrə",
    continueButton: "Davam edin",
    errorMessage: "Şifrə doğru deyil!",
  },
  jp: {
    loginTitle: "続行するためのパスワードを提供してください",
    passwordLabel: "パスワード",
    continueButton: "続ける",
    errorMessage: "パスワードが正しくありません！",
  },
  zh: {
    loginTitle: "提供密码以继续",
    passwordLabel: "密码",
    continueButton: "继续",
    errorMessage: "密码不正确！",
  },
  nl: {
    loginTitle: "Voer een wachtwoord in om verder te gaan",
    passwordLabel: "Wachtwoord",
    continueButton: "Doorgaan",
    errorMessage: "Het wachtwoord is niet correct!",
  },
  cs: {
    loginTitle: "Zadejte heslo pro pokračování",
    passwordLabel: "Heslo",
    continueButton: "Pokračovat",
    errorMessage: "Heslo není správné!",
  },
  cz: {
    loginTitle: "Zadejte heslo pro pokračování",
    passwordLabel: "Heslo",
    continueButton: "Pokračovat",
    errorMessage: "Heslo není správné!",
  },
  it: {
    loginTitle: "Inserisci una password per continuare",
    passwordLabel: "Password",
    continueButton: "Continua",
    errorMessage: "La password non è corretta!",
  },
  ru: {
    loginTitle: "Введите пароль для продолжения",
    passwordLabel: "Пароль",
    continueButton: "Продолжить",
    errorMessage: "Неверный пароль!",
  },
  uk: {
    loginTitle: "Введіть пароль для продовження",
    passwordLabel: "Пароль",
    continueButton: "Продовжити",
    errorMessage: "Пароль не вірний!",
  },
  tr: {
    loginTitle: "Devam etmek için bir şifre girin",
    passwordLabel: "Şifre",
    continueButton: "Devam Et",
    errorMessage: "Şifre doğru değil!",
  },
  pl: {
    loginTitle: "Wprowadź hasło, aby kontynuować",
    passwordLabel: "Hasło",
    continueButton: "Kontynuuj",
    errorMessage: "Hasło jest nieprawidłowe!",
  },
  da: {
    loginTitle: "Indtast adgangskode for at fortsætte",
    passwordLabel: "Adgangskode",
    continueButton: "Fortsæt",
    errorMessage: "Adgangskoden er ikke korrekt!",
  },
  sv: {
    loginTitle: "Ange lösenord för att fortsätta",
    passwordLabel: "Lösenord",
    continueButton: "Fortsätt",
    errorMessage: "Lösenordet är inte korrekt!",
  },
  fi: {
    loginTitle: "Anna salasana jatkaaksesi",
    passwordLabel: "Salasana",
    continueButton: "Jatka",
    errorMessage: "Salasana ei ole oikein!",
  },
  id: {
    loginTitle: "Masukkan kata sandi untuk melanjutkan",
    passwordLabel: "Kata Sandi",
    continueButton: "Lanjutkan",
    errorMessage: "Kata sandi tidak benar!",
  },
  no: {
    loginTitle: "Oppgi passord for å fortsette",
    passwordLabel: "Passord",
    continueButton: "Fortsett",
    errorMessage: "Passordet er ikke korrekt!",
  },
  nb: {
    loginTitle: "Oppgi passord for å fortsette",
    passwordLabel: "Passord",
    continueButton: "Fortsett",
    errorMessage: "Passordet er ikke korrekt!",
  },
  ko: {
    loginTitle: "계속하려면 비밀번호를 입력하세요",
    passwordLabel: "비밀번호",
    continueButton: "계속",
    errorMessage: "비밀번호가 정확하지 않습니다!",
  },
  ar: {
    loginTitle: "أدخل كلمة المرور للمتابعة",
    passwordLabel: "كلمة المرور",
    continueButton: "استمر",
    errorMessage: "كلمة المرور غير صحيحة!",
  },
  he: {
    loginTitle: "הזן סיסמא כדי להמשיך",
    passwordLabel: "סיסמא",
    continueButton: "המשך",
    errorMessage: "הסיסמא אינה נכונה!",
  },
  hu: {
    loginTitle: "A folytatáshoz adja meg a jelszót",
    passwordLabel: "Jelszó",
    continueButton: "Folytatás",
    errorMessage: "A jelszó nem helyes!",
  },
  ro: {
    loginTitle: "Introduceți parola pentru a continua",
    passwordLabel: "Parolă",
    continueButton: "Continuă",
    errorMessage: "Parola nu este corectă!",
  },
  bg: {
    loginTitle: "Въведете парола за да продължите",
    passwordLabel: "Парола",
    continueButton: "Продължи",
    errorMessage: "Паролата не е коректна!",
  },
  sk: {
    loginTitle: "Zadajte heslo pre pokračovanie",
    passwordLabel: "Heslo",
    continueButton: "Pokračovať",
    errorMessage: "Heslo nie je správne!",
  },
  sl: {
    loginTitle: "Za nadaljevanje vnesite geslo",
    passwordLabel: "Geslo",
    continueButton: "Nadaljuj",
    errorMessage: "Geslo ni pravilno!",
  },
  ms: {
    loginTitle: "Masukkan kata laluan untuk teruskan",
    passwordLabel: "Kata laluan",
    continueButton: "Teruskan",
    errorMessage: "Kata laluan tidak betul!",
  },
  ja: {
    loginTitle: "続行するにはパスワードを入力してください",
    passwordLabel: "パスワード",
    continueButton: "続行",
    errorMessage: "パスワードが正しくありません！",
  },
  el: {
    loginTitle: "Παρέχετε ένα κωδικό πρόσβασης για να συνεχίσετε",
    passwordLabel: "Κωδικός πρόσβασης",
    continueButton: "Συνέχιση",
    errorMessage: "Ο κωδικός πρόσβασης δεν είναι σωστός!",
  },
  vi: {
    loginTitle: "Vui lòng nhập mật khẩu để tiếp tục",
    passwordLabel: "Mật khẩu",
    continueButton: "Tiếp tục",
    errorMessage: "Mật khẩu không đúng!",
  },
};

/** Built-in gate string for `lang` ("vi", "pt-BR", ...), English if unknown. */
export const getPasswordGateDefault = (key: string, lang?: string): string => {
  const base = (lang ?? "").toLowerCase().split(/[-_]/)[0];
  const strings =
    passwordGateTranslations[base] ?? passwordGateTranslations.en;
  return strings[key] ?? passwordGateTranslations.en[key];
};
